
import { SVGObject } from 'three/examples/jsm/renderers/SVGRenderer';
import * as THREE from 'three';
export class SVGLabel {
    public Object: SVGObject;
    public TextObject: SVGObject;
    public textNode: SVGTextElement;

    private _size: number;
    private _text: string;
    private _font: string;

    public get Visible (){ return this.Object.visible};
    public set Visible(isVisible: boolean){this.Object.visible = isVisible;}

    constructor(size: number, text: string,  parameters?:Partial<{renderDistance: number, font: string, stroke:  string, background:  string, fontColor: string, border:  string}>){
        this._size = size;
        this._text = text;
        this._font = (parameters?.font ) ? parameters.font : "monospace" ;
        let fontColor = parameters?.fontColor ? parameters.fontColor.toString() : 'black';
        let background = parameters?.background ? parameters.background.toString() : 'white';
        let textWidth = this.GetTextWidth(text, this._font  + " " +  size.toString() + "px");
        let padding = {left: 20, top: 5, right: 20, bottom:5};
        let width = (textWidth + padding.left + padding.right);
        let height =size+padding.top+padding.bottom;
        // Text
        this.textNode = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        this.textNode.setAttributeNS(null, 'fill', fontColor);
        this.textNode.setAttributeNS(null, 'font', this._font  + " " +  size.toString() + "px");
        this.textNode.setAttributeNS(null, 'paint-order', 'stroke');
        this.textNode.setAttributeNS(null, 'text-anchor', 'middle'); 
        this.textNode.setAttributeNS(null, 'alignment-baseline', 'center'); 
        this.textNode.textContent = text;
        

        // Main
        const node = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        node.setAttributeNS(null, 'fill', background);
        node.setAttributeNS(null, 'x', -(width*0.5) + "px");
        node.setAttributeNS(null, 'y', (-height+padding.top) + "px");
        node.setAttributeNS(null, 'width', (width) + "px");
        node.setAttributeNS(null, 'height', (height) + "px");
        node.setAttributeNS(null, 'rx', "4px");
        node.setAttributeNS(null, 'ry', "4px");

        node.appendChild(this.textNode);

        // SVG Objects
        this.Object = new SVGObject(node);
        if(parameters?.renderDistance)
            this.Object.userData.renderDistance = parameters?.renderDistance;
        this.TextObject = new SVGObject(this.textNode);
        this.TextObject.name = "Text";
        this.Object.add(this.TextObject);
    }

    GetTextWidth(text: string, font: string) {
        let element = document.createElement('canvas');
        let context = element.getContext("2d")!;
        context.font = font;
        let width = context.measureText(text).width;
        element.remove();
        return width *1.25;
    }

    SetText(text:string ){
        this._text = text;
        let textWidth = this.GetTextWidth(text, this._font  + " " +  this._size.toString() + "px");
        let padding = {left: 10, top: 5, right: 10, bottom:5};
        let width = (textWidth + padding.left + padding.right);
        let height =this._size+padding.top+padding.bottom;

        this.Object.node.setAttributeNS(null, 'x', -(width*0.5) + "px");
        this.Object.node.setAttributeNS(null, 'y', (-height+padding.top) + "px");
        this.Object.node.setAttributeNS(null, 'width', (width) + "px");
        this.Object.node.setAttributeNS(null, 'height', (height) + "px");
        this.textNode.textContent = text;
    }

    SetSize(size: number){
        this._size = size;
        let textWidth = this.GetTextWidth(this._text, this._font  + " " +  this._size.toString() + "px");
        let padding = {left: 10, top: 5, right: 10, bottom:5};
        let width = (textWidth + padding.left + padding.right);
        let height =this._size+padding.top+padding.bottom;

        this.Object.node.setAttributeNS(null, 'x', -(width*0.5) + "px");
        this.Object.node.setAttributeNS(null, 'y', (-height+padding.top) + "px");
        this.Object.node.setAttributeNS(null, 'width', (width) + "px");
        this.Object.node.setAttributeNS(null, 'height', (height) + "px");
    }

    SetPosition(position: THREE.Vector3){
        this.Object.position.copy(position);
    }
}